import { axiosGet } from "../../react_axios/Axios";
import moment from "moment";
import { INVOICES_LIST_ACTION_TYPE, headers, invoicesListUrl } from "../../utils/constants";

export const invoices_list_action =
  (OrderID, CompanyName,ItmeCenter) => async (dispatch) => {
    try {
      const mapdata = {
        userId: sessionStorage.getItem("userId"),
        OrderID: OrderID,
        CompanyName: CompanyName,
        ItmeCenter: ItmeCenter,
      };
      const params = {
        userId: mapdata.userId === "" ? null : mapdata.userId,
        OrderID: mapdata.OrderID === "" ? null : mapdata.OrderID,
        CompanyName: mapdata.CompanyName === "" ? null : mapdata.CompanyName,
        ItmeCenter: mapdata.ItmeCenter === "" ? null : mapdata.ItmeCenter,
      };
      console.log("Invoices mapdata...", mapdata);
      const res = await axiosGet(invoicesListUrl, params,headers);
      console.log("Invoices", res);
      dispatch({
        type: INVOICES_LIST_ACTION_TYPE,
        payload: res,
      });
      return res;
    } catch (err) {
      return Promise.reject(err);
    }
  };